import {ENDPOINT_COMMITMENT} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const getCommitment = (commitmentId) => {
  return fetch(`${ENDPOINT_COMMITMENT}${commitmentId}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getListCommitmentDetails = (commitmentIds) => {
  return fetch(
    `${ENDPOINT_COMMITMENT}/commitmentDetails?commitmentIds=${commitmentIds}`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

export default {
  getCommitment,
  getListCommitmentDetails,
};
